import { postData } from "@jda/lui-portal-utilities";

import { createRequestObject, getAuthToken } from "../utility/commonUtility";
const { CLIENT_SERVICE_V1_URL } = window["env"];

export const getResourcePermissions = async (payload: any) => {
  const { subjectId, reqObj } = payload;
  let apiURL = `${CLIENT_SERVICE_V1_URL}/subjects/${subjectId}/resourcePermissions`;
  return postData<any>(createRequestObject(apiURL), reqObj, getAuthToken)
    .then((appsResponse) => {
      return appsResponse;
    })
    .catch((error) => {
      throw error;
    });
};
